module.exports = __webpack_public_path__ + "img/w15-cover.4d4b3ddc.jpg";